const navLinkStyledLogin = {
  text: 'Esqueceu a senha?',
  qrcode: 'Ler dados públicos'
};

export default navLinkStyledLogin;
